import { render } from "./stoneDetail.vue?vue&type=template&id=7c4b1658&scoped=true"
import script from "./stoneDetail.vue?vue&type=script&lang=js"
export * from "./stoneDetail.vue?vue&type=script&lang=js"

import "./stoneDetail.vue?vue&type=style&index=0&id=7c4b1658&lang=less&scoped=true"

import exportComponent from "F:\\LSDC\\trunk\\lsdc-delivery-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4b1658"]])

export default __exports__